import { Shield, Lock, Eye, Users } from "lucide-react";

export function SafetySection() {
  return (
    <section className="space-y-6 text-center">
      <h2 className="text-2xl font-display font-bold">Trygt for hele familien</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg mx-auto text-left">
        {[
          { icon: Shield, text: "Norsk selskap – data lagres i EU" },
          { icon: Lock, text: "Ingen datasalg – data brukes kun for å levere tjenesten" },
          { icon: Lock, text: "Ingen annonser. Ingen tredjeparts sporing." },
          { icon: Eye, text: "Barn trenger ikke e-post" },
          { icon: Users, text: "Rollebasert tilgang" },
        ].map((item) => (
          <div key={item.text} className="flex items-start gap-3 p-3">
            <item.icon className="h-5 w-5 text-primary mt-0.5 shrink-0" />
            <p className="text-sm">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
